import React, { useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

function closestBiggestMultipleOf4With2Decimals(value) {
  if (isNaN(value)) {
    return 1;
  }
  // Round to 2 decimal places
  const roundedValue = Number(value.toFixed(2)) * 100;

  // Find the largest multiple of 4 bigger than or equal to roundedValue
  const biggestMultiple = Math.ceil(roundedValue / 4) * 4;

  return biggestMultiple / 100;
}

export const LineChartSimple = (props) => {
  const { data, idField, visualProps, colors, locale } = props;

  let myTicks = [];
  if (data.length > 1) {
    myTicks = [data[0].jaar, data[data.length - 1].jaar];
  } else if (data.length > 0) {
    myTicks = [data[0].jaar];
  }

  // if (data[0]?.Aarschot < 0) return <p>Negatieven willen niet werken :S , Fixed door manueel ticks toe te voegen ipv tickcount te gebruiken</p>;
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        margin={{ top: 20, right: 4, left: 4, bottom: 10 }}
        data={data}
        style={{
          cursor: 'pointer',
          // backgroundColor: 'white',
          // border: '1px solid #eee',
        }}
      >
        <XAxis
          dataKey="jaar"
          hide={false}
          tickCount={0}
          interval="preserveStartEnd"
          ticks={myTicks}
          height={20}
          axisLine={false}
          style={{ fontSize: '11px' }}
        />
        <YAxis
          ticks={['dataMin', 'dataMax']}
          hide={true}
          // domain={([dataMin, dataMax]) => {
          //   return dataMin < 0 ? ['auto', 'auto'] : [0, 'auto'];
          // }}
        />
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        {visualProps.map((d, i) => {
          let count = 0;
          data.forEach((a) => {
            count = a[d.fieldName] === undefined ? count : count + 1;
          });

          const dotR = count > 1 ? 0 : 3;
          return (
            <Line
              type="monotone"
              data
              key={d.id + d.fieldName}
              dataKey={d.fieldName}
              stroke={colors[i]}
              strokeWidth={2}
              dot={{ r: dotR, strokeWidth: 2 }}
            />
          );
        })}

        {/* <Tooltip
          formatter={(value, name, props) =>
            data[0] && data[0].d3format
              ? locale.format(data[0].d3format)(value)
              : value
          }
          contentStyle={{
            fontSize: '15px',
            paddingBottom: '8px',
          }}
          itemStyle={{
            marginBottom: '0px',
            paddingBottom: '0px',
            marginTop: '0px',
            paddingTop: '0px',
          }}
          labelStyle={{
            fontWeight: 'bold',
            paddingBottom: '4px',
            marginBottom: '0px',
          }}
        /> */}
      </LineChart>
    </ResponsiveContainer>
  );
};

export const LineChartDetail = (props) => {
  const { data, idField, visualProps, colors, locale } = props;

  if (data.length === 0) return <></>;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{
            top: 0,
            right: 32,
            left: 16,
            bottom: 0,
          }}
        >
          <Legend
            verticalAlign="top"
            height={
              visualProps.length <= 1 ? 0 : visualProps.length > 3 ? 90 : 52
            }
            wrapperStyle={{
              fontSize: '14px',
              visibility: visualProps.length > 1 ? 'initial' : 'hidden',
            }}
          />

          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="jaar"
            tick={{ fontSize: '0.8em' }}
            // interval={parseInt(data[0]?.survey) === 0 ? 1 : 0}
            interval={data[0]?.isPrognose ? 1 : 0}
          />
          {data[0] && data[0].survey === '1' ? (
            <YAxis
              domain={([dataMin, dataMax]) => {
                if (data[0] && data[0].survey === '1') {
                  const myDataMax =
                    closestBiggestMultipleOf4With2Decimals(dataMax);
                  const myDomain = [0, myDataMax];
                  return myDomain;
                } else {
                  if (dataMin < 0) {
                    return [dataMin, dataMax];
                  } else {
                    return [0, dataMax];
                  }
                }
              }}
              tickCount={5}
              interval={'equidistantPreserveStart'}
              tick={{ fontSize: '0.8em' }}
              tickFormatter={(d, i) => {
                return data[0] && data[0].d3format
                  ? locale.format(data[0].d3format)(d)
                  : d;
              }}
            />
          ) : (
            <YAxis
              tickCount={5}
              interval={'equidistantPreserveStart'}
              tick={{ fontSize: '0.8em' }}
              tickFormatter={(d, i) => {
                return data[0] && data[0].d3format
                  ? locale.format(data[0].d3format)(d)
                  : d;
              }}
            />
          )}

          {visualProps.map((d, i) => {
            return (
              <Line
                // type="monotone"
                data
                key={d.id + d.fieldName}
                dataKey={d.fieldName}
                stroke={colors ? colors[i] : 'black'}
                strokeWidth={2}
                dot={{ r: 3 }}
                type="linear"
                // dot={false}
              >
                {/* {data.map((d, i) => (
                  <Cell stroke={d.color}></Cell>
                  
                ))} */}
              </Line>
            );
          })}
          <Tooltip
            formatter={(value, name, props) =>
              data[0] && data[0].d3format
                ? locale.format(data[0].d3format)(value)
                : value
            }
            contentStyle={{ fontSize: '15px', paddingBottom: '8px' }}
            itemStyle={{
              marginBottom: '0px',
              paddingBottom: '0px',
              marginTop: '0px',
              paddingTop: '0px',
            }}
            labelStyle={{
              fontWeight: 'bold',
              paddingBottom: '4px',
              marginBottom: '0px',
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export const LineChartDetailMobile = (props) => {
  const { data, idField, visualProps, colors, locale } = props;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{
            top: 0,
            right: 32,
            left: 8,
            bottom: 0,
          }}
        >
          <Legend
            verticalAlign="top"
            height={
              visualProps.length <= 1
                ? 0
                : visualProps.length > 9
                ? 200
                : visualProps.length > 6
                ? 140
                : visualProps.length > 3
                ? 90
                : 48
            }
            wrapperStyle={{
              fontSize: '11px',
              visibility: visualProps.length > 1 ? 'initial' : 'hidden',
            }}
          />

          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="jaar"
            tick={{ fontSize: '11px' }}
            // interval={parseInt(data[0]?.survey) === 0 ? 1 : 0}
            interval={
              data[0]?.isPrognose ? 2 : parseInt(data[0]?.survey) === 0 ? 1 : 0
            }
          />

          {data[0] && data[0].survey === '1' ? (
            <YAxis
              domain={([dataMin, dataMax]) => {
                if (data[0] && data[0].survey === '1') {
                  const myDataMax =
                    closestBiggestMultipleOf4With2Decimals(dataMax);
                  const myDomain = [0, myDataMax];
                  return myDomain;
                } else {
                  if (dataMin < 0) {
                    return [dataMin, dataMax];
                  } else {
                    return [0, dataMax];
                  }
                }
              }}
              tickCount={5}
              width={40}
              interval={'equidistantPreserveStart'}
              tick={{ fontSize: '11px' }}
              tickFormatter={(d, i) => {
                return data[0] && data[0].d3format
                  ? locale.format(data[0].d3format)(d)
                  : d;
              }}
            />
          ) : (
            <YAxis
              tickCount={5}
              width={40}
              interval={'equidistantPreserveStart'}
              tick={{ fontSize: '11px' }}
              tickFormatter={(d, i) => {
                return data[0] && data[0].d3format
                  ? locale.format(data[0].d3format)(d)
                  : d;
              }}
            />
          )}
          {visualProps.map((d, i) => {
            return (
              <Line
                // type="monotone"
                data
                key={d.id + d.fieldName}
                dataKey={d.fieldName}
                stroke={colors ? colors[i] : 'black'}
                strokeWidth={2}
                dot={{ r: 3 }}
                type="linear"
                // dot={false}
              >
                {/* {data.map((d, i) => (
                  <Cell stroke={d.color}></Cell>
                  
                ))} */}
              </Line>
            );
          })}
          <Tooltip
            formatter={(value, name, props) =>
              data[0] && data[0].d3format
                ? locale.format(data[0].d3format)(value)
                : value
            }
            contentStyle={{ fontSize: '11px', paddingBottom: '8px' }}
            itemStyle={{
              marginBottom: '0px',
              paddingBottom: '0px',
              marginTop: '0px',
              paddingTop: '0px',
            }}
            labelStyle={{
              fontWeight: 'bold',
              paddingBottom: '4px',
              marginBottom: '0px',
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
